export const perfil = {
    REQUISITANTE: 0,
    FORNECEDOR: 1,
    DEMANDANTE: 2,
    GERENTE: 3,
    FINALIZACAO: 4,
    FINANCEIRO: 5,
    APOIO: 6
}